export default "__VITE_ASSET__C6YfPQa2__"